module.exports = __webpack_public_path__ + "static/media/segway.702db5f8.png";